<div class="product product--summary">

	<cm-topbar title="Add new product summary" class="main-header-publisher"></cm-topbar>

	<div class="main-content">

		<div class="go-back">
			<button mat-button color="primary" (click)="goBack()">
				<span>&larr; Go back</span>
			</button>
		</div>

		<div class="container">

			<div class="row mb50" *ngIf="widgetType.width > 500 || widgetType.responsive">
				<div class="col-md-12 text-center">
					<img [src]="widgetType.demoImageUrl">
				</div>
			</div>

			<div class="row justify-content-center">

				<div class="col-auto" *ngIf="widgetType.width <=500">
					<div class="product-summary-demo">
						<img [src]="widgetType.demoImageUrl">
					</div>
				</div>

				<div class="col-lg-6 text-left">

					<mat-card class="product-summary-content">

						<mat-card-header class="mb10">
							<mat-card-title>
								<h5>Please review before submitting your request</h5>
							</mat-card-title>
						</mat-card-header>

						<mat-card-content>
              <div class="alert alert-info" role="alert">
                We are currently only accepting requests for an adhesion (sticky) placements.
              </div>
							<ul class="mat-list product-summary-list">

								<li class="mat-list-item">
									<label>Platform</label>
									<strong>{{DevicePlacementLabels[platform]}}</strong>
								</li>

								<li class="mat-list-item">
									<label>Size</label>
									<strong>{{widgetType._size}}</strong>
								</li>

								<li class="mat-list-item">
									<label>Content</label>
									<strong>{{widgetType.content}}</strong>
								</li>

								<li class="mat-list-item">
									<label>Domain</label>
									<div class="row align-items-center">
										<div class="col">
											<!--<mat-select placeholder="Select domain"-->
                                  <!--multiple-->
											            <!--[(ngModel)]="request.domainIds">-->
												<!--<mat-option *ngFor="let domain of availableDomains" [value]="domain.id">-->
													<!--{{ domain.url }}-->
												<!--</mat-option>-->
											<!--</mat-select>-->

                      <mat-select placeholder="Select domain"
                                  multiple
                                  style="min-width: 200px"
                                  [(ngModel)]="request.domainIds">
                        <!--<mat-optgroup *ngFor="let group of siteGroups" [label]="group.name"-->
                                      <!--[disabled]="group.disabled">-->
                          <mat-option *ngFor="let site of allDomains" [value]="site.id">
                            {{site.url}}
                          </mat-option>
                        <!--</mat-optgroup>-->
                      </mat-select>

                    </div>
									</div>
								</li>

								<li class="mat-list-item summary-comment">
									<!--<label>Comment</label>-->
									<mat-form-field class="w-100">
                    <textarea matInput [(ngModel)]="request.comment" placeholder="Your comment" matTextareaAutosize matAutosizeMinRows="2"
                              matAutosizeMaxRows="10"></textarea>
									</mat-form-field>
								</li>

							</ul>
						</mat-card-content>
					</mat-card>

					<div class="mat-card-outer-controls d-flex justify-content-between">
						<button mat-button color="primary" (click)="goBack()" class="large iconed">
							<i class="fas fa-times"></i>
							<span>Cancel</span>
						</button>
						<button mat-raised-button color="primary" class="large iconed"
						        [disabled]="!request.domainIds?.length"
						        (click)="submit()">
							<i class="fas fa-check"></i>
							<span>Send Request</span>
						</button>
					</div>

				</div>

			</div>
		</div>
	</div>
</div>
